import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import TicketListing from './TicketListing';
import TicketSelections from './TicketSelections';

class TicketList extends Component {
  /*static propTypes = {
    tickets: PropTypes.array.isRequired,
  }*/

  renderListings() {
    const listings = [];
    const { tickets } = this.props.store;
    if (!tickets.size) {
		return (
			<li className="list-group-item font-weight-light font-italic">
				Sale has ended.
			</li>
		);
    }
    for (const key of tickets.keys()) {
      listings.push(<TicketListing ticketId={key} key={key} />)
    }
    return listings;
  }

	renderHeadings() {		
		return (
			<li className="list-group-item d-none d-md-block font-weight-light font-italic">
				<div className="container">
					<div className="row">
						<div className="col-md-1 text-center">
							<span className="d-none d-xl-block">Image</span>
						</div>
						<div className="col-md-5">Description</div>
						<div className="col-md-2 text-center">Quantity</div>
						<div className="col-md-2 text-center">Price</div>
						<div className="col-md-2 text-center">Total</div>                        
					</div>
				</div>
			</li>
		);
	}

  render() {   
	const { tickets } = this.props.store; 
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <h4 className="card-header">
                    Tickets
                    <img
                      alt="" 
                      src="https://kabbalah.com/content/dam/kabbalah/logos/TKC_Monogram_Large_RGB.png"
                      className="rounded float-right image-fluid"
                      width="30px"
                    />
                </h4>
                <ul className="list-group list-group-flush">
					{(tickets.size > 0) && this.renderHeadings()}
                  	{this.renderListings()}
                </ul>
                <div className="card-footer">
                    <TicketSelections />
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default inject('store')(observer(TicketList));



// WEBPACK FOOTER //
// ./src/components/TicketList.js